import cn from 'classnames';
import styles from './styles.module.scss';
import { FC, ReactNode } from 'react';

interface ButtonInterface {
  children: ReactNode;
  isDisable?: boolean | undefined;
  className?: string;
  onClick: () => void;
}

const Button: FC<ButtonInterface> = ({ children, isDisable, className, onClick }) => {
  return (
    <button
      disabled={isDisable}
      className={cn(styles['Button'], className, { [styles['Button--disabled']]: isDisable })}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export { Button };
